import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

export const getPastReceipt = async ({ params }) => {
  const { menuSlug } = params;

  const response = await fetchWrapper(
    hcUrlV3(`/weekly_baskets/${menuSlug}/past-receipt`),
    buildOpts()
  );
  return handleResponse(response);
};
